import { modals } from "@mantine/modals";
import Repository from "../../_base/helper/HttpHelper";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { Button, Group, Text } from "@mantine/core";
import { IconCheck, IconX } from "@tabler/icons-react";
import {  repositorySign } from "../../_base/_const/_constVar";
const OrganizationDeleteView = ({
  ids,
  onClose,
}: OrganizationDeleteViewProps) => {
  const handleDelete = async () => {
    let url = "/api/v1/Department/delete";
    const res = await repositorySign.post(url, ids);
    if (res) {
      if (res.success) {
        await onClose();
        NotificationExtension.Success("Xóa thành công !");
      } else NotificationExtension.Fails("Xóa thất bại !");
    }
    modals.closeAll();
  };

  return (
    <div>
      <Text size="24px">Bạn có chắc chắn muốn xóa không ?</Text>
      <Group justify="center" mt="lg">
        <Button
          type="button"
          color="gray"
          onClick={() => modals.closeAll()}
          leftSection={<IconX size={18} />}
        >
          Hủy
        </Button>
        <Button
          type="button"
          color="red"
          onClick={handleDelete}
          leftSection={<IconCheck size={18} />}
        >
          Xóa
        </Button>
      </Group>
    </div>
  );
};

type OrganizationDeleteViewProps = {
  ids: (number | string)[];
  onClose: any;
};
export default OrganizationDeleteView;
